import styled from 'styled-components';
export const OptionsContainer = styled.div `
  position: absolute;
  margin: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  z-index: 2;
  display: block;
  box-sizing: border-box;
  ${({ flyoutMaxItemsCount, withFooter }) => withFooter ? 'auto' : `max-height: ${flyoutMaxItemsCount * 2.625 + 1}rem`};
  overflow-y: ${({ withFooter }) => (withFooter ? 'hidden' : 'auto')};
  ${({ theme }) => `box-shadow: 0 2px 6px rgba(${theme.colors.transparentBlack}, 0.26);`}
  padding: 0.5rem 0;
  transition: opacity 0.3s ${({ opened }) => (opened ? 'ease-in' : 'ease-out')},
    visibility 0s ${({ opened }) => (opened ? 'ease-in' : 'ease-out')}
      ${({ opened }) => (opened ? '0s' : '0.3s')};
  ${({ opened }) => `visibility: ${opened ? 'visible' : 'hidden'};`}
  ${({ opened }) => `opacity: ${opened ? '1' : '0'};`}
  ${({ openDirection = 'bottom' }) => (openDirection === 'top' ? `bottom: 100%;` : `top: 100%;`)}
  outline: none;
  > div {
    flex: 1;
    ${({ withFooter }) => (withFooter ? 'max-height: 10rem' : '')};
  }

  div[type='checkboxGroup'] {
    box-sizing: border-box;
    min-height: 2.5rem;
    border: 1px solid transparent;

    &:focus {
      outline: none;
      ${({ theme, focused }) => focused
    ? `border: 1px solid ${theme.colors.primaryLight}; outline: 1px solid ${theme.colors.primaryLight};`
    : ''};
      &.focused {
        ${({ theme }) => `border: 1px solid ${theme.colors.primaryLight}; outline: 1px solid ${theme.colors.primaryLight};`}
      }
    }

    @media (hover: hover) {
      &:hover {
        ${({ theme, disabled }) => !disabled ? `background-color: rgba(${theme.colors.transparentBlack},0.06);` : ''};

        label:before {
          background-color: transparent;
        }
      }
    }

    &:active {
      ${({ theme }) => theme.global.disableTapHighlight}

      ${({ theme, disabled }) => !disabled
    ? `border: 1px solid ${theme.colors.grey15}; background-color: ${theme.colors.grey15}; color: ${theme.colors.white};`
    : ''};

      label {
        ${({ theme, disabled }) => (!disabled ? `color: ${theme.colors.white};` : '')};

        :after {
          ${({ theme, disabled }) => (!disabled ? `border-color: ${theme.colors.white};` : '')};
        }
      }

      span {
        ${({ theme, disabled }) => (!disabled ? `color: ${theme.colors.white};` : '')};
      }

      svg {
        ${({ theme, disabled }) => (!disabled ? `fill: ${theme.colors.white};` : '')};
      }
    }
    label {
      box-sizing: border-box;
      font-size: 0.875rem;
      font-weight: 500;
      min-width: unset;
      max-width: unset;
      min-height: 2.5rem;
      > p {
        font-size: 0.875rem;
        font-weight: 500;
      }
      :before {
        top: -1px;
      }
    }
  }
`;
